import React, { useEffect, useState } from "react";
import {
  blackDeleteicon,
  editiconorange,
  rightarrowwhite,
} from "../../../images";
import TextFieldWithIcon from "../../../components/TextFieldWithIcon/TextFieldWithIcon";
import OtpInput from "react-otp-input";

import { useWindowSize } from "react-use";
import CountryCodeDropdown from "../../../components/CountryCodeDropdown/CountryCodeDropdown";

import Joi from "joi";
import http from "../../../helpers/http";
import { useAuth } from "../../../context/Auth/AuthState";
import config from "../../../config/config";
import { toast } from "react-toastify";
import ToastMsg from "../../../components/ToastMsg/ToastMsg";
import _find from "lodash/find";
import useTheme from "../../../components/useTheme/useTheme";
// import { parsePhoneNumber } from "libphonenumber-js";

const EditOwnerContact = ({
  country_code,
  phone,
  lightTheme,
  onChange,
  error,
}) => {
    const { theme } = useTheme();
  const { width } = useWindowSize();
  const [codes, setCodes] = useState([]);
  const [userCode, setUserCode] = useState({
    phone_code: "91",
    name: "India",
    iso3: "IND",
  });

  const base_url = config.api_url;

  // Fetch country codes
  const fetchCodes = async () => {
    const { data } = await http.get(base_url + "/general/countries/codes");
    if (data) setCodes(data);
  };

  useEffect(() => {
    fetchCodes();
  }, []);

  useEffect(() => {
    if (codes.length) {
      const filteredCode =
        _find(codes, { phone_code: country_code }) || codes[0];
      setUserCode(filteredCode);
    }
  }, [country_code, codes]);

  return (
    <div className="field_wrapper padding_right">
      <div className="row">
        <div className={`col-4 col-sm-4 col-md-4 ps-0`}>
          <div className="field_wrapper_1">
            <CountryCodeDropdown
              data={codes || []}
              value={userCode}
              lightTheme={lightTheme}
              textLabel="Code*"
              onChange={(event, option) => {
                if (option) {
                  setUserCode(option);
                  onChange("country_code", option.phone_code);
                }
              }}
            />
          </div>
        </div>
        <div
          className={`col-8 col-sm-8 col-md-8 ${
            width > 992 ? "pe-0" : "ps-0 pe-0"
          }`}
        >
          <div className="field_wrapper_1">
            <TextFieldWithIcon
              label="Phone*"
              icon={editiconorange}
              value={phone}
              lightTheme={lightTheme}
              type="tel" // prevent letters on mobile
              onChange={(e) => {
                let val = e.target.value.replace(/\D/g, ""); // allow only digits
                if (val.length > 10) val = val.slice(0, 10); // max 10 digits
                onChange("phone", val);
              }}
            />
            {error && <p className="error">{error}</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditOwnerContact;
